import { api } from '../client'
import type { Trends } from '../types'

export const trendsApi = {
  /** 公开；登录了会按自己的静音词滤掉一些 */
  list: () => api.get<Trends>('/trends'),
}
